import { motion } from 'framer-motion';
import { BrowserRouter, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { ApprovalSolicitation } from '../pages/ApprovalSolicitation';
import { BranchOffice } from '../pages/BranchOffice';
import { Clients } from '../pages/Clients';
import { Collaborators } from '../pages/Company/Collaborators';
// import { Friends } from '../pages/Contacts/Friends/index';
// import { ListContacts } from '../pages/Contacts/ListContacts/index';
//import { Requests } from '../pages/Contacts/Request';
import { Suggestion } from '../pages/Contacts/Suggestion/index';
//import { Demand } from '../pages/Demand';
import { Department } from '../pages/Department';
import { NotFoundError } from '../pages/Error/NotFoundError';
import { FeedPage } from '../pages/FeedPage';
import PublicFeed from '../pages/FeedPage/Public';
import { Financial } from '../pages/Financial';
import { Home } from '../pages/Home/index';
import { LegalPerson } from '../pages/LegalPerson';
import { LegalPersonAccount } from '../pages/LegalPersonAccount';
import { Login } from '../pages/Login';
import { MyValues } from '../pages/MyValues';
import { NaturalPersonAccount } from '../pages/NaturalPersonAccount';
import { RecoveryPassword } from '../pages/PasswordRecovery';
import { Profiles } from '../pages/Profiles';
import { Register } from '../pages/Register';
import { Correspondence } from '../pages/Correspondence';
import { Schedule } from '../pages/Schedule';
import { SelectedLogin } from '../pages/SelectedLogin';
import { Solicitation } from '../pages/Solicitation';
import { UserNotification } from '../pages/UserNotification';
import { Wallet } from '../pages/Wallet';
import { YourDemands } from '../pages/YourDemands';
import { YourSolicitations } from '../pages/YourSolicitations';
import AuthRoute from './AuthRoute';
import AuthRouteCollaborator from './AuthRouteCollaborator';
import { Specialties } from '../pages/Specialties';
import { Courts } from '../pages/Court';
import { BaseUserComplementRegister } from '../pages/BaseUserComplementRegister';
import { RegisterClient } from '../pages/RegisterClient';
import AuthAdm from './AuthAdm';
import { useAuth } from '../context';
import { Dashboard } from '../pages/Dashboard';
import { PrivacyPolicy } from '../pages/PrivacyPolicy';
import { Plans } from '../pages/Plans';
import { SubscribePlan } from '../pages/SubscribePlan';
import { CheckoutSuccess } from '../pages/CheckoutSuccess';
import { CheckoutFailed } from '../pages/CheckoutFailed';

const AnimationLayout = () => {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        type: 'tween',
      }}>
      <Outlet />
    </motion.div>
  );
};
export function Router() {
  const { tokenIsValid } = useAuth();
  const { location } = window;

  const redirectToFeed = () => {
    window.location.href = '/feed';
  };

  if (
    tokenIsValid &&
    (location.pathname === '/login' ||
      location.pathname === '/register' ||
      location.pathname === '/reactivateAccount' ||
      location.pathname === '/recoveryPassword' ||
      location.pathname === '/' ||
      location.pathname === '/completeRegister')
  )
    redirectToFeed();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AnimationLayout />}>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          {/* <Route path="/reactivateAccount" element={<ReactivateAccount />} /> */}
          <Route path="/recoveryPassword" element={<RecoveryPassword />} />
          <Route
            path="/user/*"
            element={
              <AuthRoute>
                <PublicFeed />
              </AuthRoute>
            }
          />
          <Route
            path="/feed"
            element={
              <AuthRoute>
                <AuthRouteCollaborator>
                  <FeedPage />
                </AuthRouteCollaborator>
              </AuthRoute>
            }
          />
          <Route
            path="/registerClient"
            element={
              <AuthAdm>
                <RegisterClient />
              </AuthAdm>
            }
          />
          <Route
            path="/legalPersonAccount"
            element={
              <AuthRoute>
                <AuthRouteCollaborator>
                  <LegalPersonAccount />
                </AuthRouteCollaborator>
              </AuthRoute>
            }
          />
          <Route
            path="/naturalPersonAccount"
            element={
              <AuthRoute>
                <NaturalPersonAccount />
              </AuthRoute>
            }
          />

          <Route
            path="/complementRegister"
            element={
              <AuthRoute>
                <BaseUserComplementRegister />
              </AuthRoute>
            }
          />
          <Route
            path="/legalPerson"
            element={
              <AuthRoute>
                <AuthRouteCollaborator>
                  <LegalPerson />
                </AuthRouteCollaborator>
              </AuthRoute>
            }
          />
          <Route
            path="/selectedlogin"
            element={
              <AuthRoute>
                <SelectedLogin />
              </AuthRoute>
            }
          />
          <Route
            path="/schedule"
            element={
              <AuthRoute>
                <Schedule />
              </AuthRoute>
            }
          />
          <Route
            path="/notification"
            element={
              <AuthRoute>
                <UserNotification />
              </AuthRoute>
            }
          />
          <Route
            path="/branch"
            element={
              <AuthRoute>
                <BranchOffice />
              </AuthRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <AuthRoute>
                <Clients />
              </AuthRoute>
            }
          />
          <Route
            path="/courts"
            element={
              <AuthRoute>
                <Courts />
              </AuthRoute>
            }
          />
          <Route
            path="/collaborator"
            element={
              <AuthRoute>
                <Collaborators />
              </AuthRoute>
            }
          />
          <Route
            path="/myvalues"
            element={
              <AuthRoute>
                <MyValues />
              </AuthRoute>
            }
          />
          <Route
            path="/profiles"
            element={
              <AuthRoute>
                <Profiles />
              </AuthRoute>
            }
          />
          <Route
            path="/approvalsolicitation/:id?"
            element={
              <AuthRoute>
                <ApprovalSolicitation />
              </AuthRoute>
            }
          />
          {/* <Route
            path="/request"
            element={
              <AuthRoute>
                <Requests />
              </AuthRoute>
            }
          /> */}
          <Route
            path="/sugestion"
            element={
              <AuthRoute>
                <Suggestion />
              </AuthRoute>
            }
          />
          {/* <Route
            path="/friends"
            element={
              <AuthRoute>
                <Friends />
              </AuthRoute>
            }
          />
          <Route
            path="/list-contacts"
            element={
              <AuthRoute>
                <ListContacts />
              </AuthRoute>
            }
          /> */}
          <Route
            path="/wallet"
            element={
              <AuthRoute>
                <Wallet />
              </AuthRoute>
            }
          />
          {/* <Route
            path="/demand"
            element={
              <AuthRoute>
                <Demand />
              </AuthRoute>
            }
          /> */}
          <Route
            path="/department"
            element={
              <AuthRoute>
                <Department />
              </AuthRoute>
            }
          />
          <Route
            path="/financial"
            element={
              <AuthRoute>
                <Financial />
              </AuthRoute>
            }
          />
          <Route
            path="/solicitation"
            element={
              <AuthRoute>
                <AuthRouteCollaborator>
                  <Solicitation />
                </AuthRouteCollaborator>
              </AuthRoute>
            }
          />
          <Route
            path="/solicitation/:id/edit"
            element={
              <AuthRoute>
                <AuthRouteCollaborator>
                  <Solicitation />
                </AuthRouteCollaborator>
              </AuthRoute>
            }
          />
          <Route
            path="/yourdemands"
            element={
              <AuthRoute>
                <YourDemands />
              </AuthRoute>
            }
          />
          <Route
            path="/yoursolicitations"
            element={
              <AuthRoute>
                <YourSolicitations />
              </AuthRoute>
            }
          />
          <Route
            path="/collaborator/solicitation"
            element={
              <AuthRoute>
                <Solicitation />
              </AuthRoute>
            }
          />
          <Route
            path="/correspondence"
            element={
              <AuthRoute>
                <Correspondence />
              </AuthRoute>
            }
          />
          <Route
            path="/specialties"
            element={
              <AuthRoute>
                <Specialties />
              </AuthRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <AuthAdm>
                <Dashboard />
              </AuthAdm>
            }
          />
          <Route
            path="/subscribe"
            element={
              <AuthRoute>
                <SubscribePlan />
              </AuthRoute>
            }
          />
          <Route
            path="/plans"
            element={
              <AuthAdm>
                <Plans />
              </AuthAdm>
            }
          />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutFailed />} />
          <Route path="*" element={<NotFoundError />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
